<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>

<div class="container">
<div class="col-md-12 col-xs-12 col-sm-12 heading p-0 mt-4 mb-4">
  <span class="span-create-edit-hoshin color">EVENT REPORT</span>
  <span class="pt-2" style="font-size: 13px;"><a href="assets/userguides/EventReportUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
</div>
<div class="budget-style">
<div class="col-lg-4 col-md-6 col-sm-12  inlineFlex paddLzero paddRzero space">         
  <span class="paddLzero">Site</span><span class="colonPadding">:</span>
  <span>{{selectedEventsDetails.siteName}}</span>
</div>

<div class="col-lg-4 col-md-6 col-sm-12 inlineFlex paddLzero space ">
    <span class="paddLzero">BPG </span><span class="colonPadding">:</span>
    <span >{{selectedEventsDetails.bpgName}}</span>
</div>

<div class="col-lg-4 col-md-6 col-sm-12 inlineFlex paddLzero paddRzero space ">
      <span class="paddLzero">Event Name </span><span class="colonPadding">:</span>
      <span>{{selectedEventsDetails.eventName}}</span>
</div>
</div> 

<div class="budget-style">
  <div class="col-lg-4 col-md-6 col-sm-12  inlineFlex paddLzero paddRzero space">         
    <span class="paddLzero">Date</span><span class="colonPadding">:</span>
    <span>{{selectedEventsDetails.eventCreateDate | date:'MM-dd-yyyy'}}</span>
  </div>
  
  <div class="col-lg-4 col-md-6 col-sm-12 inlineFlex paddLzero space ">
      <span class="paddLzero">Max. Attendees</span><span class="colonPadding">:</span>
      <span>{{selectedEventsDetails.maxAttendeece}} </span>
  </div>
  
  <div class="col-lg-4 col-md-6 col-sm-12 inlineFlex paddLzero paddRzero space ">
        <span class="paddLzero">Venue </span><span class="colonPadding">:</span>
        <span>{{selectedEventsDetails.venue}}</span>
  </div>
  </div> 

  <div class="buttons-style">
    <div class="col-lg-4 inlineFlex">         
      <span class="col-md-6 paddLzero report_type_lbl">Report Type</span> 
      <ng-select name="reportTypeName" [(ngModel)]="reportTypeName" (change)="changeDropDown($event)" placeholder ="Select Report" [items] = "reportDropdownList" bindLabel ="reportTypeName" bindValue="reportTypeName" class="col-md-6 form-control custom" required></ng-select>
    </div>

    <div class="inlineFlex paddLzero paddRzero space button_btn_align table-bottom">
      <button type="button" class="btn btn-danger" [disabled]="reportTypeName==null" (click)="generateReportClick()">GENERATE</button>
      <button type="button" class="btn btn-danger" [disabled]="eventReportData.length==0" (click)="exportAsCSV()">EXPORT TO CSV</button>
      <button type="button" class="btn btn-danger" (click)="goBack()">BACK</button>

    </div>

  </div>


</div>

<!--table-->

<p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
<div class="tabledemo1" *ngIf="tableShow">
  <div class="table-container">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <th scope="col">First Name</th>
          <th scope="col">Last Name</th>
          <th scope="col">Workday ID</th>
          <th scope="col">Email</th>
          <th scope="col">Member</th>
          <th scope="col" *ngIf="reportTypeName=='Attendance'">Registered</th>
          <th scope="col" *ngIf="reportTypeName=='Registered'">Confirmed</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of eventReportData  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
          <td>{{data.first_name}}</td>
          <td>{{data.last_name}}</td>
          <td>{{data.workday_id}}</td>
          <td>{{data.email}}</td>
          <td>{{data.member}}</td>
          <td *ngIf="reportTypeName=='Attendance'">{{data.registered}}</td>
          <td *ngIf="reportTypeName=='Registered'">{{data.confirmed}}</td>

        </tr>

      </tbody>
    </table>  

  </div>
 
  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
</div>